var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({class:['navigation-mapping-tab', { 'navigation-mapping-tab-active': _vm.isActive }],attrs:{"color":_vm.color,"x-small":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.tabTitle)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }